import { BaseService } from "./BaseService";

export class HomeService extends BaseService {
  getNotaSelectionPrograms(top) {
    return this.request(`api/Home/GetNotaSelectionPrograms/${top !== undefined && top !== null ? top : ""}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  getNotaInsights() {
    return this.request("api/Home/GetNotaInsights", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  getUpCommingPrograms(top) {
    return this.request(`api/Home/GetUpCommingPrograms/${top !== undefined && top !== null ? top : ""}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  getLatestPrograms(top) {
    return this.request(`api/Home/GetLatestPrograms/${top !== undefined && top !== null ? top : ""}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  getAudienceBoosterPrograms(top) {
    return this.request(`api/Home/GetAudienceBoosterPrograms/${top !== undefined && top !== null ? top : ""}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }
}

const homeService = new HomeService();

export default homeService;
